import api from './client';
import type { AdminAuditLogg } from './types';

export interface AdminAuditFilters {
  limit?: number;
  offset?: number;
  action?: string;
  resourceType?: string;
  actorUserId?: number;
  /** YYYY-MM-DD, inklusiv */
  fra?: string;
  /** YYYY-MM-DD, inklusiv hele dagen */
  til?: string;
}

export interface AuditEksport {
  data: Blob;
  /** Filnavn fra Content-Disposition, hvis serveren sendte det */
  filnavn?: string;
}

export const filnavnFraContentDisposition = (header: unknown): string | undefined => {
  if (typeof header !== 'string') return undefined;
  return /filename="([^"]+)"/.exec(header)?.[1];
};

export const adminAuditAPI = {
  getAll: async (filters: AdminAuditFilters = {}): Promise<{ auditLogg: AdminAuditLogg[] }> => {
    const response = await api.get('/admin/audit-logg', { params: filters });
    return response.data;
  },

  /** Last ned organisasjonens audit-logg som JSON-fil (periode + filtre) */
  eksporter: async (filters: AdminAuditFilters = {}): Promise<AuditEksport> => {
    const response = await api.get('/admin/audit-logg/eksport', {
      params: filters,
      responseType: 'blob',
    });
    return {
      data: response.data,
      filnavn: filnavnFraContentDisposition(response.headers?.['content-disposition']),
    };
  },
};
